import { render, staticRenderFns } from "./chinese_Culture_Video_Exhibition_2026.vue?vue&type=template&id=a365260c&scoped=true"
import script from "./chinese_Culture_Video_Exhibition_2026.vue?vue&type=script&lang=js"
export * from "./chinese_Culture_Video_Exhibition_2026.vue?vue&type=script&lang=js"
import style0 from "./chinese_Culture_Video_Exhibition_2026.vue?vue&type=style&index=0&id=a365260c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a365260c",
  null
  
)

export default component.exports